import FieldSet from '../../FieldSet';

import { TeamLocation } from './TeamLocation';

export class TeamLocationFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [TeamLocation];
  }

  get title() {
    return 'Location';
  }
}
